<template>
  <!-- <div class="d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <div>
      <h4>Loading...</h4>
        <b-spinner label="Loading..." variant="primary" style="width: 5rem; height: 5rem;"  />
      </div>
  </div> -->
  <div id="loading-wrapper">
    <div id="loading-text">
      LOADING
    </div>
    <div id="loading-content" />
  </div>
</template>

<script lang="ts">

export default {
  name: 'LoadingSpinner'
}
</script>
